let passwordChange = require('../../actions/account/password-change');
let utils = require('../../actions/utils');

module.exports = {
    changePassword: [
        passwordChange.ifChangePasswordInProcess,
        {
            no: [
                utils.set(['account', 'passwordChangeForm', 'inProcess'], true),
                [
                    passwordChange.changePassword, {
                        success: [
                            utils.set(['account', 'passwordChangeForm', 'result'], { success: true })
                        ],
                        wrongPassword: [
                            utils.set(['account', 'passwordChangeForm', 'result'], { error: true,
                                reason: 'прежний пароль введён неверно' })
                        ],
                        error: [
                            utils.set(['account', 'passwordChangeForm', 'result'], { error: true,
                                reason: 'что-то пошло не так, попробуйте снова' })
                        ]
                    }
                ],
                utils.set(['account', 'passwordChangeForm', 'inProcess'], false)
            ],
            yes: []
        }
    ]
};



// WEBPACK FOOTER //
// ./signals/account/password-change.js